/*
 *  Copyright (c) 2011-2024 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('LinkConfiguration', ['Settings', function(Settings){
        var NOTES = {
            public: 'This link will be publicly available.',
            login: 'This link will only be accessible to [PRODUCT_NAME] users.',
            shared: 'This link will only be accessible to users it was specifically shared to.'
        }, RESTRICTION_TYPES = {
            public: 'public',
            login: 'access',
            shared: 'shared'
        };

        return {
            getNote: function() {
                if (this.isPublicAllowed()) return NOTES.public;
                if (this.isLoginAllowed()) return NOTES.login;
                if (this.isSharedAllowed()) return NOTES.shared;
                return null;
            },

            isPublicAllowed: function() {
                return Settings['node_share_link_allow_public_links'];
            },

            isPublicWithPasswordAllowed: function() {
                return Settings['node_share_link_allow_public_links_with_password'];
            },

            isLoginAllowed: function() {
                return Settings['node_share_link_allow_login_links'];
            },

            isSharedAllowed: function() {
                return Settings['node_share_link_allow_shared_users_only'];
            },

            isTtlRequired: function() {
                return Settings['node_share_link_ttl_range_enable'];
            },

            isSingleUseOnlyRequired: function() {
                return Settings['node_share_link_single_use_only'];
            },

            canSetLinkType: function() {
                return Settings['node_share_link_allow_public_links'] ^ Settings['node_share_link_allow_login_links'] ?
                    Settings['node_share_link_allow_shared_users_only'] : Settings['node_share_link_allow_public_links'];
            },

            canSetLinkTypeOnGetLink: function() {
                return Settings['node_share_link_allow_public_links'] && Settings['node_share_link_allow_login_links'];
            },

            getTtl: function() {
                return Settings['node_share_link_ttl_max'] || 365
            },

            getPermissions: function() {
                return {
                    isSharedAllowed: this.isSharedAllowed,
                    isPublicAllowed: this.isPublicAllowed,
                    isPublicWithPasswordAllowed: this.isPublicWithPasswordAllowed,
                    isLoginAllowed: this.isLoginAllowed,
                    isTtlRequired: this.isTtlRequired,
                    isSingleUseOnlyRequired: this.isSingleUseOnlyRequired,
                    canSetLinkType: this.canSetLinkType
                };
            },

            getAccessRestrictionType: function(link) {
                return this.isLoginAllowed() ? RESTRICTION_TYPES.login : (this.isPublicAllowed() ? RESTRICTION_TYPES.public : (this.isSharedAllowed() ? RESTRICTION_TYPES.shared : null));
            }
        }
    }]);
